import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import CustomerForm from './CustomerForm';

const CustomerDetails = ({ isOpen, onClose, customer }) => {
    const isCreating = !customer;

    useEffect(() => {
        // Désactive le scroll du body quand le modal est ouvert
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        
        // Réactive le scroll quand le modal est fermé
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    // Gestion de la touche Escape pour fermer le modal
    useEffect(() => {
        const handleEscape = (event) => {
            // Vérifie si l'événement n'a pas déjà été traité par un modal enfant
            if (!event.defaultPrevented && event.key === 'Escape') {
                onClose();
                // Marquer l'événement comme traité
                event.preventDefault();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return createPortal(
        <>
            <div 
                className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 transition-opacity"
                onClick={onClose}
            />
            <div className="fixed inset-0 z-50 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <div 
                        className="relative bg-white rounded-lg shadow-xl max-w-5xl w-full"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="p-6">
                            <div className="flex items-center justify-between mb-6">
                                <h2 className="text-2xl font-bold">
                                    {isCreating ? 'Nouveau Client' : 'Détails du Client'}
                                </h2>
                                <button 
                                    className="btn btn-sm btn-circle btn-ghost"
                                    onClick={onClose}
                                >
                                    ✕
                                </button>
                            </div>

                            <CustomerForm
                                customer={customer}
                                onSuccess={onClose}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.getElementById('root')
    );
};

export default CustomerDetails; 